export const DEFAULT_CHART_CONFIG = {
    chart: {
        style: {
            fontFamily: '"PwC Helvetica Neue", sans-serif !important'
        },
        options3d:{
            enabled: false,
            alpha:'',
            beta:'',
            depth:'',
            viewDistance:'',

        }
    },
    lang: {
        thousandsSep: ',',
        numericSymbols: ['K', 'M', 'B','T']
    },
    boost: {
        enabled: true,
        useGPUTranslations: true,
      },
    title: '',
    credits: {
        enabled: false
    },
    yAxis: {
        stackLabels: {
            enabled: false,
            formatter:'',
            format:'',
        }
    },
    xAxis: {
        scrollbar: {
            enabled: false
        },
        min: 0,
        step: 1,
        tickInterval: 1,
        categories: [],
        labels: {
            // formatter: function (): any {
            //     if (typeof this.value === 'string' && this.value.includes("_")) {
            //         this.value = this.value.split("_").join(" ")
            //     }
            //     return this.value
            // }
        }

    },
    exporting: {
        allowHTML: true,
        buttons: {
            contextButton: {
                menuItems: ["viewFullscreen", "printChart", "separator", "downloadPNG", "downloadJPEG", "downloadPDF", "downloadSVG"]
            }
        },
        menuItemDefinitions: {
            chartOptions: {
                text: 'Chart Options'
            },
        }
    },
    tooltip: {
        enabled: true,
    },
    legend: {
        enabled: true
    },
    plotOptions: {
        series: {
            dataLabels: {
                enabled: false,
                inside: true
            }

        },
        sunburst:{
            allowDrillToNode: true,
            cursor: 'pointer',
            dataLabels: {
                // format: '{point.name}',
                filter: {
                    property: 'innerArcLength',
                    operator: '>',
                    value: 16
                },
                rotationMode: 'circular'
            },
            levels: [{
                level: 1,
                levelIsConstant: false,
                dataLabels: {
                    filter: {
                        property: 'outerArcLength',
                        operator: '>',
                        value: 64
                    }
                }
            }, {
                level: 2,
                colorByPoint: true
            },
            {
                level: 3,
                colorVariation: {
                    key: 'brightness',
                    to: -0.5
                }
            }, {
                level: 4,
                colorVariation: {
                    key: 'brightness',
                    to: 0.5
                }
            }]

        },
        variablepie: {
            allowPointSelect: true,
            cursor: 'pointer',
            showInLegend: true,
            minPointSize: 50,
            innerSize: '40%',
            zMin: 10,
            dataLabels: {
                enabled: true,
                format: '<b>{point.name} : </b> {point.percentage:.2f} %',
            },
        },

        packedbubble: {
            minSize: '20px',
            maxSize: '150px',
            draggable:false,
            // zMin: 0,
            // zMax: 1000,
            // useSimulation: false,
            layoutAlgorithm: {
                enableSimulation:false,
                splitSeries: false,
                gravitationalConstant: 0.02
            },
            dataLabels: {
                enabled: true,
                format: '{point.name}',
                // filter: {
                //     property: 'percentage',
                //     operator: '>',
                //     value: 50
                // },
                // style: {
                //     color: 'black',
                //     textOutline: 'none',
                //     fontWeight: 'normal'
                // }
            }
        },
        pie: {
            allowPointSelect: true,
            cursor: 'pointer',
            showInLegend: true,
            dataLabels: {
                enabled: true,
                format: '<b>{point.name} : </b> {point.percentage:.2f} %',
            },
        },
    },
    series: [],

    customColors:{
        enabled: false,
    }
};
